








































































































import { Component, Vue, Prop } from "vue-property-decorator";
import AreaExpansionChartController from "./components/charts/area-expansion/AreaExpansionChartController.vue";
import CompareFarmsOwnersController from "./components/compare-farms-owners-controller/CompareFarmsOwnersController.vue";
import HarvestResultTableController from "./components/harvest-result-table/HarvestResultTableController.vue";
import StackedAreaScoreController from "./components/charts/stacked-area-score/StackedAreaScoreController.vue";
import YieldBoxPlotController from "./components/charts/yield-boxplot/YieldBoxPlotController.vue";
import CreditScoreController from "./components/charts/credit-score/CreditScoreController.vue";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { Analysis, YIELD_SCORE_TYPE } from "@/api/analyses/types";
import ComparativeScoreController from "./components/comparative-score/ComparativeScoreController.vue";
import * as analysesService from '@/services/analyses';
import Loading from '@/components/loading/Loading.vue';

@Component({
  name: "CompareFarmsOwners",
  components: {
    AreaExpansionChartController,
    CompareFarmsOwnersController,
    HarvestResultTableController,
    AgroIcons,
    ComparativeScoreController,
    YieldBoxPlotController,
    StackedAreaScoreController,
    CreditScoreController,
    Loading,
  },
})
export default class CompareFarmsOwners extends Vue {

  @Prop(String)
  private uuid!: string;

  @Prop({ type: String, default: "" })
  private source?: string;

  private loadingCount: number = 0;
  private ready: boolean = false;
  private loadError: boolean = false;

  private onLoadingChange(value: boolean) {
    if (value) this.loadingCount++;
    else if (this.loadingCount > 0) this.loadingCount--;
  }

  private async mounted() {
    try {
      await analysesService.getByUuid(this.uuid!);
    } catch {
      this.loadError = true;
    } finally {
      this.ready = true;
    }
  }

  private async beforeDestroy() {
    await analysesService.cleanup();
  }

  private get analysis(): Analysis {
    return this.$store.state.analyses.analysesContext;
  }

  private get isCreditScoreUser() {
    return this.$store.getters['user/isCreditScoreUser'];
  }

  get harvestSeason(): string {
    const value = this.$route.query.harvestSeason;
    if (value === 'SUMMER' || value === 'WINTER') return value;
    return this.analysis ? this.analysis.harvestSeason : 'SUMMER';
  }

  set harvestSeason(value: string) {
    if (this.$route.query.harvestSeason === value) return;
    this.$router.replace({
      query: { ...this.$route.query, harvestSeason: value },
    }).catch(() => {});
  }

  get currentCropType(): string {
    if (this.analysis.unified) {
      return this.harvestSeason === 'WINTER'
        ? (this.analysis.winterCropType || 'CORN')
        : (this.analysis.summerCropType || this.analysis.cropType);
    }
    return this.harvestSeason === 'WINTER' && this.analysis.cropType === 'SOY'
      ? 'COTTON'
      : this.analysis.cropType;
  }

}
